<tt-page *ngIf="!!inputListLanguages">
    <tt-card class="col-xs-12 sp-0" *ngIf="['mobile', 'tablet'] | mediaQuery">
        <ng-container *ngTemplateOutlet="tabs"></ng-container>

        <div [hidden]="selectedBgUnitName === 'longname'">
            <ng-container *ngTemplateOutlet="inputListShortNames"></ng-container>
        </div>

        <div [hidden]="selectedBgUnitName === 'shortname'">
            <ng-container *ngTemplateOutlet="inputListLongNames"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div *ngIf="['laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="shortname">
                <ng-container *ngTemplateOutlet="inputListShortNames"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="longname">
                <ng-container *ngTemplateOutlet="inputListLongNames"></ng-container>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-8 p-5">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #tabs>
    <ng-container *ngIf="!!inputListLanguages">
        <tt-tabs [(ttSelectedId)]="selectedBgUnitName">
            <tt-tab ttId="shortname" ttLabel="shortname"></tt-tab>
            <tt-tab ttId="longname" ttLabel="longname"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #inputListShortNames>
    <ng-container *ngIf="!!inputListLanguages">
        <tt-input *ngFor="let item of inputListLanguages" [ttLabel]="item.language_name" [(ttModel)]="item.shortname"></tt-input>
    </ng-container>
</ng-template>

<ng-template #inputListLongNames>
    <ng-container *ngIf="!!inputListLanguages">
        <tt-input *ngFor="let item of inputListLanguages" [ttLabel]="item.language_name" [(ttModel)]="item.longname"></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!inputListLanguages">
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgUnitName.buttons" tt-model="vm.model.bgUnitName.selected" tt-change="vm.selectBgUnitName($value)"></tt-buttons-radio>

        <div ng-show="vm.model.bgUnitName.selected === 'shortname'">
            <div ng-repeat="item in vm.model.inputListLanguageNames">
                <tt-input class="col-xs-12 sp-0" tt-label="{{item.language_name}}" tt-model="item.shortname" tt-change="item.shortname = $value" tt-placeholder=""></tt-input>
            </div>
        </div>

        <div ng-show="vm.model.bgUnitName.selected === 'longname'">
            <div ng-repeat="item in vm.model.inputListLanguageNames">
                <tt-input class="col-xs-12 sp-0" tt-label="{{item.language_name}}" tt-model="item.longname" tt-change="item.longname = $value" tt-placeholder=""></tt-input>
            </div>
        </div>

        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>

<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === true">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="shortname" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>

            <div ng-repeat="item in vm.model.inputListLanguageNames">
                <tt-input class="col-xs-12 sp-0" tt-label="{{item.language_name}}" tt-model="item.shortname" tt-change="item.shortname = $value" tt-placeholder=""></tt-input>
            </div>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="longname" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>

            <div ng-repeat="item in vm.model.inputListLanguageNames">
                <tt-input class="col-xs-12 sp-0" tt-label="{{item.language_name}}" tt-model="item.longname" tt-change="item.longname = $value" tt-placeholder=""></tt-input>
            </div>
        </tt-card>
    </div>

    <tt-card class="col-xs-12 col-md-8 p-5">
        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
